import { sendOtp } from '../../../data/repositories/authRepository.js';

export const requestOtp = (contactNumber) => sendOtp(contactNumber);
